export default function UploadIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_425_14429)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0C10.0204 0.00620777 8.10822 0.720203 6.609 2.013C5.46 3.003 4.6275 4.293 4.413 5.5875C1.899 6.1425 0 8.3325 0 10.977C0 14.049 2.562 16.5 5.6715 16.5H11.25V8.5605L8.031 11.781C7.89017 11.9218 7.69916 12.0009 7.5 12.0009C7.30084 12.0009 7.10983 11.9218 6.969 11.781C6.82817 11.6402 6.74905 11.4492 6.74905 11.25C6.74905 11.0508 6.82817 10.8598 6.969 10.719L11.469 6.219C11.5387 6.14916 11.6214 6.09374 11.7125 6.05593C11.8037 6.01812 11.9013 5.99866 12 5.99866C12.0987 5.99866 12.1963 6.01812 12.2874 6.05593C12.3786 6.09374 12.4613 6.14916 12.531 6.219L17.031 10.719C17.1718 10.8598 17.2509 11.0508 17.2509 11.25C17.2509 11.4492 17.1718 11.6402 17.031 11.781C16.8902 11.9218 16.6992 12.0009 16.5 12.0009C16.3008 12.0009 16.1098 11.9218 15.969 11.781L12.75 8.5605V16.5H19.032C21.753 16.5 24 14.355 24 11.6595C24 9.2055 22.137 7.206 19.749 6.8685C19.3845 2.9985 16.035 0 12 0ZM11.25 21.75V16.5H12.75V21.75C12.75 21.9489 12.671 22.1397 12.5303 22.2803C12.3897 22.421 12.1989 22.5 12 22.5C11.8011 22.5 11.6103 22.421 11.4697 22.2803C11.329 22.1397 11.25 21.9489 11.25 21.75Z"
          fill="#207E7D"
        />
      </g>
      <defs>
        <clipPath id="clip0_425_14429">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
